<p-toast></p-toast>

<!--Loader-->
<div class="loading" *ngIf="load">
  <div class="ui active inverted dimmer">
    <div class="ui text loader">Loading</div>
  </div>
  <p></p>
</div>

<p-confirmDialog [style]="{width: '64vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text">
</p-confirmDialog>

<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header" data-background-color="purple">

          <div class="row col-12 triplediv" style="display: inline-block; padding: 10px;">
            <div class="row col-12" style="display: inline-block;">
              <div class="col-7" style="float: left;">
                <div class="col-7" style="float: left;">
                  <div class="triplediv box foo" style="width: 100%; display: inline-block;" data-toggle="modal"
                    data-target="#newMethod" (click)="openNewModal()">
                    <div style="width: 100%; display: inline-block;">
                      <div class="iconsection">
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAARDSURBVGhD7ZhdaFRHFMfXalsQtRYprR+IqJASc+/uNvgFWkWlLGbn3ljZh9ZiEhSx1L614AcSFEEflCJJdmbTaNuHPigiLXloHqSlBeuDIJUqpVCVtCBapFK0Fu1H+j+Tk83czexH7q5uKPcHh929c86Zc+bM191YRERERMT/mrj/0Uwnrda7ntwaF2qHm85udkR2RWPm9DOsMnFp3pF7OiFUW1zIrxH8P3FPDY0Roe5BPk94uQ1sNrFwhUohgZ+swRcRV8jzTency+yivmQypydj+hyJe/JfW7DlBAPwALZb2F29GJqEaXLCGqAnB11P9aBKuxxfbcfo78HzM3j2e6EuTUO0b2OnTx6M5v7CoPDsBuT1WGfnU6wWoDHTPQ0V2IdE/wjayb/ddG4Vqz0+4r5cgNHcyRXoRzDnqHMzGDz7Ylnq+Aw2KYnbkm2Cr59Ne6piczo3lVVqCy1GJPAZld/sdIwI9c14t9ak6F6M6t0x/bhp+R431w44fgej/KfZkVVoS22Rc9lsXMD2LdMXqnyz2LQMBTo4YHZQSjCqh9gsFPDxfcCfp5ZzU3XQdmg6HhZ5H3P4A8fPrm7c2P3S0tauWcm0WkkL/pVNajabhgL+3w/0JdQA1uTaqiqTSJ14AeW9azrG74tYhPNZpSS0TpyW7PMjsjh1/FluKgoNjtlfvl9PfRf6BoB9/1jAmVBXmzO557i5LAlfvVlg/zY3FYUGybQJCh208iCdWaxeHmdT7zxMn18DTlrlMm6uiDCJJL2uObTIh4MetQ2IkIdZ3Y7rZZOYk5/YTlwE8RWrVUyYREagM8Tx1KtI6iSk4IxSQ5hmGVYdhe5IGIGjSKLo+eAItZfVK6aaRExoI0Fst01fiPcW3QxYhRiahAqcCiqNFXqHYIOKqVUiRNzvTSD4wDkGf+9yM02n3G6zUYuQD1HOL7FGPtZJCvkjjQqbWNFVpQMNL0558VSf6Rc+Pw20C9lOduyiLEjkoOkPckE3NIkPXyy8sEH6Q5/MafWaxZ9dMFgJX25k04qgM8vcBDDIfzV4fdMtN1Z5bjwjZKOiZEIkMQJi/MH0pV/G0OG3gYeix2X9qiiZTBVJEDTlTX96ymOe5ncCdDzIujXBmkyVSRCFg48bw0I6uR8aDy+zbs0IJFODJOiKg8G/l48ZPvW1B19+GXmIkt2tdn3Y0MnAd7VJEIi3PZ+ETkQNDDfot7vRhoSQvm6oMfS/Fn8Njb4y6auLGa9q04340WE2UIUqvdk+SZa0qkXYYa+asdLvNWs6p2gFumZjO7seVNBZd+j9uc7ERe8SrLEjtk2D7mGsNowrsusQ/JhLGR88v9VNghtRIK6iVx1aREjmkd1w4ggSeOAI+QaHbYf+R0IJr9gcTARBEmcdL9vA4ZYB78WurwQM+1Ch86gU/X97rS4i1CV89tOltvIEIiIiIiIiIiIiakss9h/K4dJB4GvsyQAAAABJRU5ErkJggg==">
                      </div>
                      <div class="textsection">
                        <h5 style="color: #000;"><strong> Add Package size</strong></h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="output row col-12" style="border: 1px solid #fcfcfc; padding: 15px 0px; margin-top: 20px;">
            <div class="col-8"></div>
            <div class="col-2" style="margin-top: 10px;">
              <button class="remove-btn" style="float: right;" (click)="removeCurrencys()"
                [disabled]="checkedItems?.length==0">
                <i class="pi pi-trash"></i> Delete Package(s)
              </button>
            </div>



            <!-- dynamic table -->
            <div *ngIf="listproductSize?.length>0" style="margin: auto; width: 100%; margin-top:20px;">
              <p-table id="films-grid" headerTitle="product sizes" [paginator]="true" [value]="listproductSize"
                [totalRecords]="productSizeCount" [rows]="15">

                <ng-template pTemplate="header" let-columns let-rowData>
                  <tr>
                    <th>
                      <div class="checkbox abc-checkbox">
                        <input id="allopen" type="checkbox" name="isActive" [(ngModel)]="allchecked"
                          (click)="checkall()">
                        <label for="allopen"></label>
                      </div>
                    </th>
                    <th>
                      Name
                    </th>
                    <th>
                      Limit Length
                    </th>
                    <th>
                      Limit weight
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-columns="columns" let-expanded="expanded">
                  <tr>

                    <td>
                      <div class="checkbox abc-checkbox">
                        <input id="open{{item.id}}" type="checkbox" name="isActive" [(ngModel)]="item.checked"
                          (click)="checkItem(item)">
                        <label for="open{{item.id}}"></label>
                      </div>
                    </td>
                    <td>
                      <strong>{{item?.name}}</strong>
                    </td>
                    <td>
                      <strong>{{item?.length}}</strong>
                    </td>
                    <td>
                      <strong>{{item?.weight}}</strong>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>





          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--report order uploaded-->
<p-dialog [(visible)]="AlertsModal" [style]="{width: '64vw'}" [baseZIndex]="10000" [modal]="true"
  styleClass="p-fluid p-dialog-delete" header="upload Discount Report">
  <div class="ui success message">
    <div class="header">
      <i class="check circle icon"></i> <strong>Success:</strong>
    </div>
    <p> {{count}} discounts </p>

  </div>
  <div class="ui yellow message">
    <div class="header">
      <i class="info circle icon"></i> <strong>Exception:</strong>
    </div>
    <div style="margin-left: 20px;">
      <template *ngFor="let i of exceptionReport">
        <li>{{i}}</li>
      </template>
    </div>
  </div>
</p-dialog>

<!------------------------------------------------------>
<p-dialog [(visible)]="newMethodModal" [style]="{width: '64vw'}" [baseZIndex]="10000" [modal]="true"
  styleClass="p-fluid p-dialog-delete" header="">

  <div class="modal-dialog modal-lg">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-bold mt">New Product Size(s)</h5>

      </div>
      <div class="modal-body">

        <form (ngSubmit)="onSubmit()" #productSizeForm="ngForm">
          <div class="form-group">
            <a href="https://docs.google.com/spreadsheets/d/1gTM2cQ14nrbwvWClldOhZaUp7vKJTO2GEF8MRF2Tm7k/edit#gid=0"
              target="_blank">Template </a>
          </div>
          <div class="form-group">
            <label for="url">spreadsheet url</label>
            <input type="text" class="form-control" id="url" [(ngModel)]="model.url" name="url" required #url="ngModel">
          </div>
          <div class="form-group">
            <label for="sheet">sheet name</label>
            <input type="text" class="form-control" id="sheet" [(ngModel)]="model.sheetName" name="sheet" required
              #sheet="ngModel">
          </div>
          <button type="button" class="btn btn-default" [disabled]="!productSizeForm.form.valid"
            (click)="newProductSize(); productSizeForm.reset()">Save</button>
          <button class="ui button" data-dismiss="modal" (click)="productSizeForm.reset()">Cancel</button>

        </form>

        <!-- - -->

      </div>
    </div>
  </div>
</p-dialog>
